import { FunctionComponent } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import { LoadingSpinner } from '../../component/Spinner';

const Loading: FunctionComponent = () => {
  return (
    <Container>
      <Row>
        <Col xs={6} md="auto">
          <LoadingSpinner />
        </Col>
      </Row>
    </Container>
  );
};

export default Loading;
